module.exports = __webpack_public_path__ + "images/stickers/taco-pixel@2x.56fca0dee66a7f8b7b8c.png";